'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    getBackgroundImage = function getBackgroundImage(color) {
  var encodedColor = encodeURIComponent(color);
  return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\'' + encodedColor + '\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")';
},
    componentTheme = function componentTheme(baseTheme) {
  var _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      shape = _baseTheme$vstui.shape,
      size = _baseTheme$vstui.size,
      typography = _baseTheme$vstui.typography,
      cloud2 = color.cloud.getShade(2),
      ninja11 = color.ninja.getShade(11),
      black57 = 'rgba(0, 0, 0, 0.57)',
      backgroundImage = getBackgroundImage(color.transparent),
      backgroundImage_invalid = getBackgroundImage(color.error),
      backgroundImage_invalidFocus = getBackgroundImage(color.error);
  return (0, _themes.createComponentTheme)(baseTheme, {
    TextAreaControl_width: '270px',
    InputControl_minHeight_small: size.small,
    InputControl_minHeight_medium: size.medium,
    InputControl_minHeight_large: size.large,
    TextAreaControl_backgroundColor: color.surface,
    TextAreaControl_backgroundColor_disabled: color.transparent,
    TextAreaControl_backgroundColor_readOnly: cloud2,
    TextAreaControl_backgroundImage: backgroundImage,
    TextAreaControl_backgroundImage_invalid: backgroundImage_invalid,
    TextAreaControl_backgroundImage_invalidFocus: backgroundImage_invalidFocus,
    TextAreaControl_backgroundPosition_small: 'right 12px top ' + (size.small - 2 - 14) / 2 + 'px',
    TextAreaControl_backgroundPosition_medium: 'right 12px top ' + (size.medium - 2 - 14) / 2 + 'px',
    TextAreaControl_backgroundPosition_large: 'right 14px top ' + (size.large - 2 - 14) / 2 + 'px',
    TextAreaControl_backgroundSize: '14px 14px',
    TextAreaControl_borderColor: 'rgba(0, 0, 0, 0.43)',
    TextAreaControl_borderColor_focus: ninja11,
    TextAreaControl_borderColor_disabled: 'rgba(0, 0, 0, 0.20)',
    TextAreaControl_borderColor_invalid: color.error,
    TextAreaControl_borderColor_invalidFocus: ninja11,
    TextAreaControl_borderStyle: shape.borderStyle,
    TextAreaControl_borderWidth: shape.borderWidth,
    TextAreaControl_borderRadius: shape.borderRadius,
    TextAreaControl_fontFamily: typography.fontFamily,
    TextAreaControl_fontSize_small: typography.fontSize,
    TextAreaControl_fontSize_medium: typography.fontSize,
    TextAreaControl_fontSize_large: typography.fontSize + 2,
    TextAreaControl_fontWeight: typography.fontWeightRegular,
    TextAreaControl_color: color.onSurface,
    TextAreaControl_color_disabled: black57,
    TextAreaControl_color_readOnly: black57,
    TextAreaControl_boxShadow_focus: '0 0 0 1px ' + ninja11,
    TextAreaControlPlaceholder_fontWeight: typography.fontWeightLight,
    TextAreaControlPlaceholder_color: black57
  });
};

exports.default = componentTheme;